import React from 'react';
import styles from './styles.module.scss';

const CancelButton = ({ onHandleClick }) => (
  <button onClick={onHandleClick} className={styles.cancelButton}>Cancel</button>
)

export default CancelButton; 